import {  useRef } from "react";

export const NavBar = () => {
  const navLinks = useRef();

  function showMenu() {
    navLinks.current.classList.add("showMenu");
  }
  function closeMenu() {
    navLinks.current.classList.remove("showMenu");
  }

  return (
    <nav className="relative p-[4vw] lg:px-[8vw]  mb-6 flex justify-between items-center ">
      {/* site logo */}
      <div className=" w-24 md:w-36">
        <img src="images/creditry-logo-main.svg" alt="site-logo" />
      </div>

      {/* Nav links  */}

      <div
        ref={navLinks}
        className="invisible lg:visible absolute top-0 left-0 py-4 lg:p-0 border-b border-gray-300 bg-white w-full  lg:w-[80%]  text-[#333333] text-sm font-medium lg:static lg:border-none "
      >
        <div className="  relative flex flex-col lg:flex-row gap-y-8 justify-center items-center lg:justify-between">
          <button
            className=" lg:hidden block absolute right-0 top-2 h-8 w-8"
            onClick={closeMenu}
          >
            <img src="images/icons/cancel.svg" alt="cancel" />
          </button>
          <div className=" text-[#477BE1]">
            <a href="#">Home</a>
          </div>
          <div>
            {" "}
            <a href="#">About Us</a>
          </div>
          <div>
            {" "}
            <a href="#">Features</a>
          </div>
          <div>
            {" "}
            <a href="#">Partnership</a>
          </div>
          <div>
            {" "}
            <a href="#">Blog</a>
          </div>
          <div>
            {" "}
            <a href="#">FAQs</a>
          </div>
          <div>
            <button className=" bg-[#8524D6] font-medium text-white h-[3rem] w-[12rem] rounded-md block">
              Join our waitlist
            </button>
          </div>
        </div>
      </div>

      {/* menu btn */}
      <button className=" h-12 w-12 lg:hidden" onClick={showMenu}>
        <img src="images/icons/hamburger-menu.svg" alt="menu-button" />
      </button>
    </nav>
  );
};
